export function getPreference<T>(name: string): T|null {
    let p = getPreferences();
    return p[name];
}

export function setPreference<T>(name: string, value: T) {
    let p = getPreferences();
    p[name] = value;
    setPreferences(p);
}

let preferences: null | {[key: string]: any} = null;

function getPreferences(): {[key: string]: any} {
    if (preferences !== null) {
        return preferences;
    }

    let matches = /preferences=([a-zA-Z0-9\-_\.!~*'()%]+)/.exec(document.cookie);
    let result: {[key: string]: any};

    if (matches === null) {
        result = {};
    }
    else {
        let decodedJson = decodeURIComponent(matches[1]);
        result = JSON.parse(decodedJson);
    }

    // closed captions used to be stored in a separate cookie that predates the preferences cookie.
    if (result.closedCaptions == null) {
        result.closedCaptions = getIsCaptionsCookieSet();
    }

    preferences = result;
    return result;
}

function setPreferences(preferences: {[key: string]: any}) {
    let json = JSON.stringify(preferences);
    let encodedJson = encodeURIComponent(json);
    let date = new Date();
    date.setTime(date.getTime() + (365 * 24 * 60 * 60 * 1000));
    let expires = "; expires=" + date.toUTCString();
    document.cookie = "preferences=" + encodedJson + expires + "; path=/";
}

function getIsCaptionsCookieSet(): boolean {
    let matches = /closedcaptions=(true)|(false)/.exec(document.cookie);
    if (matches === null) return false;
    return matches[1] === "true";
}